module.exports = __webpack_public_path__ + "static/img/4.7af0850.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/ppt/4.jpg
// module id = 3FW6
// module chunks = 1